import { configureStore, createSlice } from '@reduxjs/toolkit';

// Basic UI slice for app state
const uiSlice = createSlice({
  name: 'ui',
  initialState: {
    loading: false,
    error: null,
    notifications: [],
    theme: 'light'
  },
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    addNotification: (state, action) => {
      state.notifications.push(action.payload);
    },
    removeNotification: (state, action) => {
      state.notifications = state.notifications.filter(
        notification => notification.id !== action.payload
      );
    },
    setTheme: (state, action) => {
      state.theme = action.payload;
    }
  }
});

// Auth slice for user authentication
const authSlice = createSlice({
  name: 'auth',
  initialState: {
    user: null,
    token: null,
    isAuthenticated: false
  },
  reducers: {
    login: (state, action) => {
      state.user = action.payload.user;
      state.token = action.payload.token;
      state.isAuthenticated = true;
    },
    logout: (state) => {
      state.user = null;
      state.token = null;
      state.isAuthenticated = false;
    }
  }
});

// Export actions
export const { 
  setLoading, setError, addNotification, 
  removeNotification, setTheme 
} = uiSlice.actions;

export const { login, logout } = authSlice.actions;

// Configure the Redux store
export const store = configureStore({
  reducer: {
    ui: uiSlice.reducer,
    auth: authSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false
    })
}); 